import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solution() {
  return (
    <section className="solution-serve-easy case-about-sec case-about-left">
      <Container>
        <Row className="align-items-center justify-content-lg-between justify-content-center flex-lg-row flex-column-reverse">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className=""
          >
            <div className="image text-xl-start text-center position-relative d-lg-block d-flex flex-column-reverse">
              <StaticImage
                src="../../../images/case-studies/serve-easy/solution-main.webp"
                alt="The Challenge"
                className="image-big"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={657}
                height={922}
              />
              <div class="image-small">
                  <StaticImage
                    src="../../../images/case-studies/serve-easy/solution-small.webp"
                    alt="The Challenge"
                    className=""
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={544}
                    height={417}
                  />
              </div>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="mb-lg-0 mb-4">
            <div class="content">
              <h2>
              Solution We Proposed
              </h2>
              <p>We proposed a comprehensive, four-step solution:</p>
              <ul>
                <li>
                    <h3><span className="icon"></span>Interface Design</h3>
                    <p>Developed an intuitive, responsive interface optimized for all devices. The UI/UX was tailored to minimize staff training time and reduce operational errors.</p>
                </li>
                <li>
                    <h3><span className="icon"></span>Performance Optimization</h3>
                    <p>Leveraged cloud infrastructure to ensure high-speed processing and real-time data synchronization. Implemented load balancing and caching mechanisms to maintain performance under peak traffic conditions.</p>
                </li>
                <li>
                    <h3><span className="icon"></span>Scalability & Integration</h3>
                    <p>Designed the system to be modular and scalable, allowing for easy integration with third-party tools such as accounting software, CRM systems, and loyalty programs.</p>
                </li>
                <li>
                    <h3><span className="icon"></span>Security & Payment Gateway</h3>
                    <p>Integrated a PCI DSS-compliant payment gateway with end-to-end encryption, ensuring secure and swift transactions.</p>
                </li>
              </ul>
            </div>
          </Col>
          
        </Row>
      </Container>
    </section>
  );
}

export default Solution;
